import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { toLocalTimestampLiteral } from 'Data/format.js'
import { useMutation } from 'Data/Api'
import { useDataValue, useDataChange } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

import createTaskMutation from './mutation-create-task.graphql.js'

import { FREQUENTLY_USED_VALUE_KEYS } from 'Data/constants.js'
import { setFrequentlyUsedSelectionValue } from 'Logic/localStorage.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutationCreateTask] = useMutation(createTaskMutation)

  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  let current_user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  let xid = useDataValue({
    context: 'global',
    path: 'current_location.xid',
    viewPath: props.viewPath,
  })

  let changeLetter = useDataChange({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let letterParams = useDataValue({
    context: 'modal',
    path: 'letter_params',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ args, value, change }) {
    switch (args.type) {
      case 'create_task': {
        let { error, data } = await executeMutationCreateTask({
          location_id: current_location_id,
          order: Date.now(),
          board_id: value.board_id,
          stage_id: value.stage_id,
          title: value.title,
          description: value.description,
          priority: value.priority,
          due_date: value.due_date && toLocalTimestampLiteral(value.due_date),
          resource_schema: value.patient?._id ? 'vaxiom' : null,
          resource_table: value.patient?._id ? 'patients' : null,
          resource_id: value.patient?._id,
          assignees: value.assignee?.id
            ? [{ user_id: value.assignee?.id }]
            : [],
          task_tags: value.tags.map(tag => ({
            tag_id: tag.id,
          })),
          resources: value.action?.id
            ? [
                {
                  type: value.action.id,
                  resource_id: value.action.document_template,
                  resource_schema: 'vaxiom',
                  resource_table: 'document_templates',
                  document_id: value.action.document_id,
                  metadata: {
                    recipient_id: value.action.recipient_id,
                    postal_address_id: value.action.postal_address_id,
                    tooth_chart_snapshot_id:
                      value.action.tooth_chart_snapshot_id,
                    tooth_marking_ids: value.action.tooth_marking_ids,
                    ...letterParams,
                  },
                },
              ]
            : [],
        })

        if (error) {
          notify(notifyError(`Error creating task`))
          return
        }

        if (value.assignee?.id && value.assignee?.id !== current_user_id) {
          setFrequentlyUsedSelectionValue({
            key: FREQUENTLY_USED_VALUE_KEYS.TASK_ASSIGNEES,
            value: value.assignee,
            xid,
          })
        }

        changeLetter(next => {
          next.task_id = data.insert_tasks_tasks_one.id
        })

        notify(notifySuccess(`Task created`))

        setFlowTo(normalizePath(props.viewPath, '../No'))

        break
      }

      default:
    }
  }
}
